import * as React from 'react';

// This component is to ensure icons have similar spacing even if they may have different dimensions
const SVGWrapper = ({
  children,
  width = 36,
  height = 36,
}: {
  children: React.ReactElement;
  width?: number;
  height?: number;
  // TODO(jkemp): Using inline styles since the view box doesn't remain consistent across icons if it is done using emotion. This will be looked into in
  // a follow up PR
}) => <div style={{ width, height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{children}</div>;

export default SVGWrapper;
